// S1 葫芦广告屏
import { FC, useRef } from 'react'
import clsx from 'clsx'
import { IS1 } from '@/common/pd-meta-components-types'
import TitleAndDesc from '../../title-and-desc'
import PdMedia from '@/components/pd-media/pd-media'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(useGSAP, ScrollTrigger)
const S1: FC<IS1> = ({ theme, title, desc, productMedia = '', innerMediaUrlList = [] }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const productContainerRef = useRef<HTMLDivElement>(null)
  const titleAndDescRef = useRef<HTMLDivElement>(null)
  const innerMediaGroupRef = useRef<HTMLDivElement>(null)

  useGSAP(() => {
    if (!innerMediaUrlList.length) return
    ScrollTrigger.refresh()
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#main',
        trigger: containerRef.current,
        start: 'top top',
        end: () => `+=${window.innerHeight * 3}`,
        pin: true,
        pinType: 'fixed',
        scrub: 1,
      },
    })

    tl.to(innerMediaGroupRef.current, {
      opacity: 1,
    })

    tl.to(titleAndDescRef.current, {
      top: '25vh',
    })

    let transformOriginY = 'center'
    if (innerMediaGroupRef.current) {
      const computedStyle = window.getComputedStyle(innerMediaGroupRef.current)
      const innerTop = parseFloat(computedStyle.top)
      const innerHeight = parseFloat(computedStyle.height)
      transformOriginY = `${innerTop + innerHeight / 2}px`
    }
    tl.to(
      productContainerRef.current,
      {
        scale: 20,
        transformOrigin: `center ${transformOriginY}`,
      },
      '<'
    )
    return () => {
      tl.kill()
    }
  }, [innerMediaUrlList])

  return (
    <div
      className={clsx(
        'w-full h-fit',
        'py-15 laptop:py-30 overflow-hidden',
        `pd-theme-${theme}`,
        'bg-container-primary',
        'pointer-events-none'
      )}
      ref={containerRef}
    >
      <div className={clsx('w-full max-w-300 mx-auto relative')}>
        <div ref={titleAndDescRef} className="relative z-10">
          <TitleAndDesc title={title} desc={desc} />
        </div>
        <div
          className={clsx('w-225px h-575px mx-auto', 'laptop:w-72 laptop:h-735px', 'relative')}
          ref={productContainerRef}
        >
          <PdMedia src={productMedia} mask={false} object="fill" />
          <div
            ref={innerMediaGroupRef}
            className={clsx(
              'absolute',
              'left-50px right-50px top-30 bottom-60',
              'laptop:left-15 laptop:right-15 laptop:top-150px laptop:bottom-295px',
              'flex flex-col',
              'opacity-0'
            )}
          >
            {innerMediaUrlList.map((item) => (
              <div key={item} className={clsx('flex-1 shrink-0')}>
                <PdMedia src={item} mask={false} object="fill" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default S1
